/* Top-level React error boundary (BUG_TRACKING_AND_FIXING.md §2).
 *
 * Catches errors thrown during render that window.onerror misses — React would otherwise
 * unmount the whole tree silently. Reports them to the BUG_LRS pipeline (via bugReporter)
 * and shows a minimal fallback with a Reload button so the user is never stuck on a blank page.
 */
import { Component } from "react";
import { reportCaughtError } from "./bugReporter.js";
import { T } from "./i18n.jsx";

export default class BugErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Extract the first concrete component name from React's componentStack (e.g. "    in App").
    let component = "unknown";
    try {
      const m = (info && info.componentStack ? String(info.componentStack) : "").match(/\s*in (\w+)/);
      if (m) component = m[1];
    } catch { /* ignore */ }
    try {
      reportCaughtError(error, component, { componentStack: info && info.componentStack });
    } catch { /* a failing reporter must never block the fallback UI */ }
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div style={{ maxWidth: 480, margin: "12vh auto", padding: 24, fontFamily: "system-ui, sans-serif", textAlign: "center" }}>
        <h2 style={{ marginBottom: 8 }}><T>Something went wrong</T></h2>
        <p style={{ color: "#666", marginBottom: 20 }}><T>The error has been reported. Reloading usually fixes it.</T></p>
        <button
          onClick={() => { try { location.reload(); } catch { /* ignore */ } }}
          style={{ padding: "8px 20px", fontSize: 15, cursor: "pointer", borderRadius: 6, border: "1px solid #ccc", background: "#fff" }}
        >
          <T>Reload</T>
        </button>
      </div>
    );
  }
}
